import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteAcceptedItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackQuoteAcceptedParameters
    extends TrackEventListParameters<"has_notes" | "type", null, TrackQuoteAcceptedItem> {}

const trackQuoteAccepted = (parameters: TrackQuoteAcceptedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "quote_accepted", ...parameters }, options);
};

export default trackQuoteAccepted;
